import { render } from "./LinkLoader.vue?vue&type=template&id=180d2119"
import script from "./LinkLoader.vue?vue&type=script&lang=js"
export * from "./LinkLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__